// Role Reducer
import {
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAIL,
  GET_ROLES_RESET,
  GET_ROLE_BY_ID,
  GET_ROLE_BY_ID_SUCCESS,
  GET_ROLE_BY_ID_FAIL,
  GET_ROLE_BY_ID_RESET,
  CREATE_ROLE,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAIL,
  CREATE_ROLE_RESET,
  UPDATE_ROLE,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAIL,
  UPDATE_ROLE_RESET,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  DELETE_ROLE_RESET,
  GET_ROLES_DROPDOWN,
  GET_ROLES_DROPDOWN_SUCCESS,
  GET_ROLES_DROPDOWN_FAIL,
  GET_ROLES_DROPDOWN_RESET,
} from '../actions/roleAction';

const initialState = {
  getRolesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getRoleByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  createRoleState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateRoleState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  deleteRoleState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getRolesDropdownState: {
    apiState: 'idle',
    data: [],
    message: null,
    errors: null,
    error: null,
  },
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROLES:
      return {
        ...state,
        getRolesState: { ...state.getRolesState, apiState: 'loading' },
      };
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        getRolesState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Roles retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ROLES_FAIL:
      return {
        ...state,
        getRolesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch roles',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ROLES_RESET:
      return {
        ...state,
        getRolesState: initialState.getRolesState,
      };

    case GET_ROLE_BY_ID:
      return {
        ...state,
        getRoleByIdState: { ...state.getRoleByIdState, apiState: 'loading' },
      };
    case GET_ROLE_BY_ID_SUCCESS:
      return {
        ...state,
        getRoleByIdState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Role retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ROLE_BY_ID_FAIL:
      return {
        ...state,
        getRoleByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch role',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ROLE_BY_ID_RESET:
      return {
        ...state,
        getRoleByIdState: initialState.getRoleByIdState,
      };

    case CREATE_ROLE:
      return {
        ...state,
        createRoleState: { ...state.createRoleState, apiState: 'loading' },
      };
    case CREATE_ROLE_SUCCESS:
      return {
        ...state,
        createRoleState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Role created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_ROLE_FAIL:
      return {
        ...state,
        createRoleState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create role',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_ROLE_RESET:
      return {
        ...state,
        createRoleState: initialState.createRoleState,
      };

    case UPDATE_ROLE:
      return {
        ...state,
        updateRoleState: { ...state.updateRoleState, apiState: 'loading' },
      };
    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        updateRoleState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Role updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_ROLE_FAIL:
      return {
        ...state,
        updateRoleState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update role',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_ROLE_RESET:
      return {
        ...state,
        updateRoleState: initialState.updateRoleState,
      };

    case DELETE_ROLE:
      return {
        ...state,
        deleteRoleState: { ...state.deleteRoleState, apiState: 'loading' },
      };
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        deleteRoleState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Role deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_ROLE_FAIL:
      return {
        ...state,
        deleteRoleState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete role',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_ROLE_RESET:
      return {
        ...state,
        deleteRoleState: initialState.deleteRoleState,
      };

    case GET_ROLES_DROPDOWN:
      return {
        ...state,
        getRolesDropdownState: { ...state.getRolesDropdownState, apiState: 'loading' },
      };
    case GET_ROLES_DROPDOWN_SUCCESS:
      return {
        ...state,
        getRolesDropdownState: {
          apiState: 'success',
          data: action.response.data || action.response || [],
          message: action.response.message || 'Roles retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ROLES_DROPDOWN_FAIL:
      return {
        ...state,
        getRolesDropdownState: {
          apiState: 'error',
          data: [],
          message: action.response?.message || action.response || 'Failed to fetch roles',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ROLES_DROPDOWN_RESET:
      return {
        ...state,
        getRolesDropdownState: initialState.getRolesDropdownState,
      };

    default:
      return state;
  }
};

export default roleReducer;

